<template>
    <div id="checkout">
    <menu-default/>

    <main class="page payment-page">
      <section class="int-form">
        <div class="container">
          <div class="block-heading">
            <h2><i class="fa fa-credit-card"></i> Pagamento</h2>
          </div>

          <form>
            <div class="card-details">
              <h3 class="title text-warning" v-show="loadingBoleto"><i class='fa fa-spinner fa-spin'></i> Aguarde enquanto seu boleto está sendo gerado</h3>
              <h3 class="title text-success" v-show="!loadingBoleto && !errorFound">Seu Boleto foi gerado!</h3>
              <h3 class="title text-danger" v-show="errorFound">Erro encontrado ao gerar boleto!</h3>
              <div class="row">
                <div class="form-group col-sm-12" v-show="!errorFound">
                  Para ter acesso a sua publicação, o pagamento do boleto precisa ser confirmado pelo sistema.
                  Essa confirmação acontece no máximo 48hrs após o boleto ter sido pago.
                  Aguarde a confirmação por e-mail ou acompanhe através da plataforma.
                </div>
                <div class="form-group col-sm-12  text-danger" v-show="errorFound">
                  {{ errorFound }}<br/>
                  <button type="button" class="btn btn-primary btn-block" @click="redirectURL({name: 'orders'})">Verifique seus pedidos</button>
                </div>
              </div>
              <hr/>
            </div>
            <div class="card-details" style="padding-top: 0">
              <div class="row" v-show="linkBoleto">
                <div class="form-group col-sm-12">
                  <button type="button" class="btn btn-primary btn-block" @click="printBoleto()">Imprimir Boleto</button>
                  <a href="#" @click="redirectURL({name: 'orders'})" class="text-center w-100" style="display: block; margin-top:10px">Verifique seus pedidos</a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
    <footer-default/>
    </div>
</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import { mapState } from 'vuex'
  import order from '../api/order'
  import mixins from "../helpers/mixins"
  export default {
    name: "Payment",
    mixins: [mixins],
    data(){
      return{
        order: false,
        loadingBoleto: false,
        linkBoleto: '',
        errorFound: ''
      }
    },
    computed: {
      ...mapState(['logged', 'cart']),
      priceSum() {
        let priceSum = 0.00;
        let router = this.$router
        if(this.cart){
          this.cart.forEach(function(product) {
            priceSum = Number(priceSum) + Number(product.price)
          });
        } else {
          router.push({name: 'home'})
        }
        return priceSum
      }
    },
    methods: {
      printBoleto(){
        window.open(this.linkBoleto, '_blank');
      }
    },
    components: { menuDefault, footerDefault },
    mounted() {
      this.loadingBoleto = true;
      this.order = this.$route.params.order;
      if(this.order){
        order.makeBoleto(this.order).then((response) => {
          if(response.status === 200){
            this.loadingBoleto = false;
            this.linkBoleto = response.data['transaction_link']
            this.$store.dispatch('cleanCart')
          } else {
            this.loadingBoleto = false
            this.errorFound = 'Um erro foi encontrato, por favor contate-nos'
          }
        }).catch(errors => {
          this.loadingBoleto = false
          this.errorFound = errors['error']
        })
        } else {
            this.loadingBoleto = false
            this.errorFound = 'Um erro foi encontrato, por favor contate-nos'
      }
    }
  }
</script>

<style scoped>

</style>
